module.exports = __webpack_public_path__ + "static/97defb653b558ea2e53ad8778f2cba525abcd3b2bddd984a48a23ff6d616b0f7-8b8db563d978f7b670469cb8ebaa503a.png";